import { useState, useEffect } from 'react'
import useTranslate from '../../../i18n/useTranslate'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

export type OptType = {
    label: string
    value: string
}

type Resulttype = {
    irb_id: number
    name_en: string
    name_th: string
}
type responseType = {
    message: string
    status: number
    result: Resulttype[]
}

/**
 * รายการ REC สำหรับ dropdown หน้า "เอกสารดาวน์โหลด" โดยเฉพาะ
 * แยกจาก useIRB เพราะหน้านี้เปิด/ปิดว่าจะให้เลือก REC ไหนได้ ไม่เท่ากับหน้าอื่น
 * ตัวกรองอยู่ใน SP_LUT_GET_IRB_DOWNLOAD_DOCUMENT
 */
const useIRBDownloadDocument = () => {
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const callApi = useCallApi()
    const [irb, setIrb] = useState<OptType[]>([])

    const getIRB = async () => {
        const { data } = await callApi.axiosGet<responseType>({
            url: umServinceURL.getIrbDownloadDocument,
        })
        const lookup = (data?.result ?? []).map((itm) => ({
            label: lang === 'en' ? itm.name_en : itm.name_th,
            value: itm.irb_id.toString(),
        }))
        setIrb(lookup)
        return lookup
    }

    useEffect(() => {
        getIRB()
    }, [translate.languageStore.currentLanguage])

    return { irb, getIRB }
}

export default useIRBDownloadDocument
